import tagularModule from 'js/store/helpers/tagular.js'
import tagularAuthenticatedModule from 'js/store/helpers/tagular-authenticated.js'

const formType = 'CONTACT'
const stepType = 'CONFIRMATION'
const stepName = 'Verify_Identity_Emailonly'

/**
 * This event fires when an OIM form becomes visible on the screen
 */
document.addEventListener('om.Campaign.load', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null

  tagularModule.formViewed(formType, formName, formId)
})

/**
 * This event fires when an OIM form submit button is clicked
 */
document.addEventListener('om.Optin.init.submit', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const formFields = eventDetails.Form.inputs.map(input => {
    const labels = [...input.labels]

    return {
      fieldId: input.id,
      fieldLabel: labels.length ? labels[0].innerText : '',
      fieldName: input.name,
      fieldType: input.type,
      fieldValue: input.value
    }
  })

  tagularModule.formSubmitted(formId, formName, formFields, formType)
})

/**
 * This event fires when an OIM form submit is successful
 */
document.addEventListener('om.Optin.success', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const stepId = window.purchaseId
  const email = event.detail.Optin.data.fields.email
  const body = { email }

  const anonymousId =
    window._Tagular &&
    window._Tagular.webContext &&
    window._Tagular.webContext.anonymousId

  const sessionId =
    window._Tagular &&
    window._Tagular.webContext &&
    window._Tagular.webContext.sessionId

  const instanceId =
    window._Tagular &&
    window._Tagular.webContext &&
    window._Tagular.webContext.instanceId

  if (anonymousId) {
    body['anonymousId'] = anonymousId
  }

  if (sessionId) {
    body['sessionId'] = sessionId
  }

  if (instanceId) {
    body['anonymousId'] = instanceId
  }

  //Post to Deposits OIM webhook to create a new bedrock user
  const oimWebhook =
    window.env === 'prod'
      ? 'https://optinmonster-webhook.bankrate.com'
      : 'https://optinmonster-webhook.qa.bankrate.com'
  fetch(`${oimWebhook}/createUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then(() => {
      tagularAuthenticatedModule.formOutcomeReceived(
        formType,
        formName,
        formId,
        stepName,
        stepType,
        stepId
      )
    })
    .catch(error => {
      console.error('Error:', error)
    })
})

/**
 * This event fires when an OIM form submit fails
 */
document.addEventListener('om.Optin.error', function(event) {
  const eventDetails = event.detail.Campaign
  const formName = eventDetails.data.name
  const formContainer = eventDetails.contain
  const formId = formContainer && formContainer.id ? formContainer.id : null
  const stepId = window.purchaseId

  tagularAuthenticatedModule.formErrored(
    formType,
    formName,
    formId,
    stepName,
    stepType,
    stepId
  )
})

/**
 * This event fires when an OIM redirect occurs
 */
document.addEventListener('om.Action.redirect', function(event) {
  const campaignDetails = event.detail.Campaign
  const campaignName = campaignDetails.data.name || 'NOT PROVIDED'
  const campaignId = campaignDetails.data.id || 'NOT PROVIDED'

  /**
   * Note: we're very limited by the data OIM provides back to us,
   * so much of this event is limited to hard-coded strings, or the
   * Campaign Name / ID, which is generally the only usable, unique
   * pieces of data.
   */
  tagularModule.elementClicked(
    {
      location: campaignName,
      position: `${campaignName}_position`,
      elementType: 'Button',
      text: `${campaignName}_Button`,
      htmlId: `${campaignName}_${campaignId}`,
      name: campaignName
    },
    `Redirect from ${campaignName}`,
    `link from ${campaignName}`,
    window.purchaseId
  )
})
